// extracted by mini-css-extract-plugin
export default {"price":"B9-z","priceRow":"C9-z","onSale":"D9-z","msrpLabelPrice":"E9-z","msrpLabel":"F9-z","originalPrice":"G9-z","percentOff":"H9-z"};